import { useEffect, useState } from 'react';

// Ten sam próg co breakpoint mobilny w App.css — układ karty meczu i to,
// ile z meczu da się na niej pokazać, muszą przełączać się w jednym punkcie.
const NARROW_QUERY = '(max-width: 480px)';

function queryList(): MediaQueryList | null {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return null;
  }

  return window.matchMedia(NARROW_QUERY);
}

export function useNarrowViewport(): boolean {
  const [narrow, setNarrow] = useState(() => queryList()?.matches ?? false);

  useEffect(() => {
    const list = queryList();

    if (list === null) {
      return;
    }

    function update(event: MediaQueryListEvent): void {
      setNarrow(event.matches);
    }

    setNarrow(list.matches);

    // Safari before 14 only knows the legacy addListener/removeListener pair.
    if (typeof list.addEventListener !== 'function') {
      list.addListener(update);

      return () => list.removeListener(update);
    }

    list.addEventListener('change', update);

    return () => list.removeEventListener('change', update);
  }, []);

  return narrow;
}

export default useNarrowViewport;
